import Icon from '../components/Icon.vue'

Icon.register({
  flag: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M349.6 98.8c40.5 0 82.6-15.9 116.9-31.9 21.2-9.9 45.5 5.6 45.5 29v243.1c0 10.5-5.2 20.4-13.8 26.4-35.8 24.6-74.3 40.9-122.5 40.9-67.4 0-111.6-34.8-165.2-34.8-50.9 0-86.1 10.1-114.4 22.1v94.4c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-386.1c-14.5-10.1-24-26.9-24-45.9 0-31.7 26.3-57.3 58.3-56 28.5 1.2 51.8 24 53.6 52.4 0.1 1 0.1 2.6 0.1 3.6 0 5.7-1.7 14.7-3.7 20 20.7-7.6 43.1-12 68-12 67.4 0 111.6 34.8 165.2 34.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flag.js
// module id = 1363
// module chunks = 0